const HeatCell = function (container, x, y, dataColors, uiGen) {
  this.uiGen = uiGen;
  this.container = container;
  this.x = x;
  this.y = y;
  this.dataColors = dataColors;
  this.dataColorIndicators = [];
  this.generateElement();
};

HeatCell.prototype.generateDataColorIndicators = function () {
  for (let i = 0; i < this.dataColors.length; i++) {
    const color = this.dataColors[i];
    const dataIndicator = this.uiGen.generateAndAddHTML(this.element, {
      attributes: {
        class: 'data_color_indicator',
        style: 'background-color: ' + color,
      },
    });

    dataIndicator.css('opacity', 0);
    dataIndicator.css('filter', 'alpha(opacity=' + 0 + ')');

    dataIndicator.color = color;

    this.dataColorIndicators[i] = dataIndicator;
  }
};

HeatCell.prototype.update = function (newIndicatorValues) {
  let currentIndicator;
  for (let i = 0; i < this.dataColorIndicators.length; i++) {
    currentIndicator = this.dataColorIndicators[i];
    let newValue = newIndicatorValues[i];
    if (newValue > 0 && newValue < 0.1) {
      newValue += 0.05;
    }
    currentIndicator.css('opacity', newValue);
    currentIndicator.css('filter', 'alpha(opacity=' + newValue + ')');
  }
};

HeatCell.prototype.generateElement = function () {
  this.element = this.uiGen.generateAndAddHTML(this.container, {
    type: 'td',
    attributes: {
      class: 'heat_cell',
    },
  });

  this.generateDataColorIndicators();
};

export default HeatCell;
